"use strict";

Shopify.theme.jsSlideshowExperts  = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsSlideshowExperts = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors
	let $nav = $section.find('[data-nav-experts] > div')
    
    var $slideshow = $section.find('[data-slideshow-experts]').removeClass('is-hidden');
    var $slider = $slideshow.flickity({
      wrapAround: false,
      draggable: true,
      imagesLoaded: true,
      cellAlign:'left',
      prevNextButtons :false,
      pageDots :false,
      watchCSS: true
    });
    setTimeout(function () {
      $slider.flickity('resize');
    }, 500);
    
    $slider.on('dragMove.flickity', function( event, pointer ) {
      let $cursor = $('.cursor');
      if(!$cursor.length){
      	$slider.off('dragMove.flickity')
        return
      }
      $cursor.css({
          top: event.clientY - $cursor.height() / 2,
          left: event.clientX - $cursor.width() / 2
      });
    });
    
    $nav.on('click',function(){
      $nav.removeClass('is-active')
      $(this).addClass('is-active')
      let index = $(this).data('index')
      $slider.flickity( 'select', index, false, false )
    })
    $slider.on( 'change.flickity', function( event, index ) {
     $nav.removeClass('is-active')
     $nav.eq(index).addClass('is-active')
    });
  },
  blockSelect: function blockSelect($section, blockId) {
    var $slider = $section.find('[data-image-experts]');
    var $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');
    $slider.flickity('select', $sliderIndex, true, true);
  },
  unload: function unload($section) {}
};